// extracted by mini-css-extract-plugin
export default {"container":"spinner_container__UPLzn","spinner":"spinner_spinner__6LOe0"};